import { Injectable } from '@angular/core';
import { PDFDocumentProxy, PDFPageProxy } from 'pdfjs-dist/types/src/display/api';
import * as pdfjsLib from 'pdfjs-dist';

(pdfjsLib as any).GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${(pdfjsLib as any).version}/pdf.worker.min.mjs`;

@Injectable({
  providedIn: 'root'
})
export class PdfService {
  private pdf: PDFDocumentProxy | null = null;

  public loadPdf(url: string): Promise<PDFDocumentProxy> {
    return (pdfjsLib as any).getDocument(url).promise.then((pdf: PDFDocumentProxy) => {
      this.pdf = pdf;
      return pdf;
    });
  }

  public getPage(pageNumber: number): Promise<PDFPageProxy> {
    if (!this.pdf) {
      return Promise.reject('PDF not loaded');
    }
    return this.pdf.getPage(pageNumber);
  }
}
